
import './style.less'

import { h, Fragment } from 'preact'
import { useState, useRef, useEffect, useLayoutEffect } from 'preact/hooks'
import classnames from 'classnames'

import TitleText from '@components/title-text'
import ImageLoad from '@components/image-load'
import VideoInline from '@components/video-inline'
import { ButtonIconArrowDownScroll } from '@components/button'
import ScrollHeader from '@components/scroll-header'

import { withHydration } from '@util/hydrate'
import { useIsIntersecting } from '@util/intersection'
import { useScrollYPosition } from '@util/useScrollPosition'
import { easeInQuad, easeInCubic } from '@util/transition'


function minmax(min, max, val) {
	return Math.min(max, Math.max(min, val))
}


const HeroCircle = ({ 
	title = '', 
	subtitle = '', 
	image = null, 
	video = null,
	fade = true
}) => {
	
	if (!image && !video) return <ScrollHeader title={title} meta={subtitle} />

	const circleRef = useRef()
	const [ref, shown] = useIsIntersecting('-10% 0px')
	const [loaded, setLoaded] = useState(false)
	const y = useScrollYPosition()

	const onPlaying = event => {
		setLoaded(true)
		event.currentTarget.style.opacity = 1
	}

	const background = <>
		{ image && <ImageLoad {...image} onScroll={false} loading="eagar" onLoaded={() => !loaded && setLoaded(true)} class="object-fit object-fit--fill"></ImageLoad> }
		{ video && <VideoInline autoplay muted onPlaying={onPlaying} {...video} class="object-fit object-fit--fill" style="opacity:0"></VideoInline> }
	</>

	useEffect(() => {
		if (circleRef.current.once) return
		circleRef.current.once = true
		const el = circleRef.current
		const { bottom } = el.getBoundingClientRect()
		window.addEventListener('scroll', () => {
			const y = window.pageYOffset
			if (y < bottom) requestAnimationFrame(() => {
				el.style.setProperty('--multiplier', 1 + easeInQuad(minmax(0, 1, y/bottom)))
				el.style.setProperty('--multiplier-dot', easeInCubic(minmax(0, 1, 1 - y/bottom)).toFixed(2))
				el.style.setProperty('--animation', y ? 'none' : '')
			})
		})
	}, [circleRef])

	return (
		<section class={classnames('hero-circle', loaded && 'hero-circle--loaded')}>
			
			<div ref={circleRef} class={classnames('hero-circle__bg', fade && 'hero-circle__bg--fade')}>{background}</div>

			{ (title || subtitle) && 
				<div ref={ref} class="hero-circle__overlay">	
					<TitleText lines={[ title, subtitle ]} trigger={shown && loaded} />
				</div>
			}

			<div class="hero-circle__button">
				<ButtonIconArrowDownScroll />
			</div> 
	    </section>
	)
}


export default withHydration(HeroCircle)